// this file added by Bearer Web Developer
import { observer } from "mobx-react-lite";
import React from "react";
import { useAppState } from "../../../../../../states/app-state";
import Send from "./send";
import { Button } from "@mui/material";
import Second from "./second";
import Edit from "./edit";
import styles from './buttons.module.scss';
import { useThemeMode } from "../../../../../../states/contexts/theme";

interface Props {
    getRegisterMobileCode: () => Promise<void>
    setLoading: React.Dispatch<React.SetStateAction<boolean>>
}
const Buttons: React.FC<Props> = observer(({ getRegisterMobileCode, setLoading }) => {

    const appState = useAppState();
    const { accountVerification } = appState;
    const verifying = accountVerification?.mobileCodeSituation === "Verifying";
    const edit = accountVerification?.mobileCodeSituation === "Edit";
    const verified = accountVerification?.mobileCodeSituation === "Verified";
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <>
            {verified &&
                <div className={styles.verified_part}>
                    <div className={styles.verified}>Verified</div>
                </div>
            }
            {
                !verified
                &&
                <>
                    {<Send setLoading={setLoading} />}
                    <div className={`${styles.restart_part}`} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                        <Button className={`${styles.restart}`} disabled={verifying}
                            onClick={getRegisterMobileCode}
                        >
                            {
                                verifying || theme === 'dark' ?
                                    <img src={`/restart-lightgrey.webp`} alt="restart" width={28} height={28} />
                                    : <img src={`/restart-white.webp`} alt="restart" width={28} height={28} />
                            }
                        </Button>
                    </div>
                    {verifying && <Second />}
                    {edit && <Edit />}
                </>
            }
        </>
    )
})
export default Buttons;